<script setup lang="ts">
import type { HotelDetailsEventSource } from '@apps/main/new-desktop/core/models';
import { useBrowserStore } from '@apps/main/new-desktop/core/stores';
import { StayTag } from '@apps/main/new-desktop/modules/stayTag';

import { AppLinkButton } from '@libs/ui';
import { isFeatureToggleActive } from '@libs/feature-toggle';

import type { Stay } from '../../../models';

import HotelStayCardRoom from './HotelStayCardRoom.vue';

interface HotelStayCardDescriptionProps {
  stay: Stay;
  source: HotelDetailsEventSource;
}
const props = defineProps<HotelStayCardDescriptionProps>();

interface HotelStayCardDescriptionEmits {
  (eventName: 'more-information'): void;
}

const emit = defineEmits<HotelStayCardDescriptionEmits>();

const browserStore = useBrowserStore();
</script>

<template>
  <div class="hotel-stay-card-description">
    <div class="rooms">
      <HotelStayCardRoom
        v-for="(room, index) in props.stay.rooms"
        :key="index"
        :room="room"
      />

      <div v-if="isFeatureToggleActive('dev-info')">
        <textarea
          :value="
            JSON.stringify(
              {
                isRefundable: props.stay.stayId.isRefundable,
                selectionType: props.stay.selectionType,
                rooms: props.stay.rooms.map((room) => ({
                  roomCode: room.roomCode,
                  roomTypeId: room.roomTypeId,
                  boardBasis: room.boardBasis,
                })),
              },
              null,
              2
            )
          "
          rows="12"
          wrap="off"
          readonly
        />
      </div>
    </div>
    <StayTag
      v-if="props.stay.tag"
      :stay-tag="props.stay.tag"
      :wide="browserStore.isSmallerThan1200px"
    />
    <AppLinkButton
      size="s"
      :text="$t('planner.more_information')"
      @click="emit('more-information')"
    />
  </div>
</template>

<style scoped lang="scss">
.hotel-stay-card-description {
  display: flex;
  flex-flow: column;
  gap: var(--spacing-16);

  min-width: -webkit-fill-available;
  min-width: fill-available;
  align-items: start;

  .rooms {
    width: -webkit-fill-available;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-16);
  }
}
</style>
